<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div v-if="isSchedule && !isDisabled && isCancelClick">
      <div class="grid line-text">
        <div class="col-12 lg:col-6">
          <label for="startDate" class="control-label" v-tooltip>
            {{ lmodel.pubDealStartDate }}
          </label>
          <Calendar
            id="calendar-24h"
            v-model="vmodel1.pubStartDate"
            lang="en"
            :disabled="dealStatus == 0 || dealStatus == 4"
            :placeholder="lmodel.pubDealStartDatePlaceholder"
            showTime
            hourFormat="24"
            dateFormat="yy-mm-dd"
            showIcon
            :minDate="new Date()"
            class="w-full mt-1 calBorder"
            :panelStyle="{ 'z-index': '1006' }"
            :class="{
              'p-invalid': !valmodel.pubStartDate || modelstate.pubStartDate,
            }"
          />
          <span
            v-if="valmodel.pubStartDate.$invalid === true"
            class="p-error"
            :style="
              valmodel.pubStartDate.$error ? 'display:block;' : 'display:none;'
            "
            >{{ staticData.st_date }}</span
          >
          <span v-if="modelstate.pubStartDate" class="p-error">
            {{ modelstate.pubStartDate }}
          </span>
        </div>

        <div class="col-12 lg:col-6">
          <label for="endDate" class="control-label" v-tooltip>
            {{ lmodel.pubDealEndDate }}
          </label>
          <Calendar
            id="calendar-24h"
            v-model="vmodel1.pubEndDate"
            lang="en"
            :placeholder="lmodel.pubDealEndDatePlaceholder"
            showTime
            hourFormat="24"
            dateFormat="yy-mm-dd"
            showIcon
            :minDate="new Date()"
            class="w-full mt-1 calBorder cal1"
            :panelStyle="{ 'z-index': '1006' }"
            :class="{
              'p-invalid': !valmodel.pubEndDate,
            }"
          />
          <span
            v-if="valmodel.pubEndDate.$invalid && vmodel.rePublishDate != null"
            class="p-error"
            >{{ staticData.end_datemust }}</span
          >
          <span
            v-if="valmodel.pubEndDate.$invalid && vmodel.rePublishDate == null"
            class="p-error"
            >{{ staticData.end_dategr }}</span
          >
        </div>

        <div class="col-12 lg:col-6 custom-settings">
          <div class="toggle-button">
            <ToggleButton
              v-model="showGeneralSettings"
              onIcon="toggle-on"
              offIcon="toggle-off"
              class="toggle-btn"
            />
            <!-- <span
              :class="{
                'toggle-on': showGeneralSettings,
                'toggle-off': !showGeneralSettings,
              }"
              @click="showGeneralSettings = !showGeneralSettings"
            ></span>-->

            <label id="custom-settings" class="custom-settings-button">
              <span>{{ staticData.pausewidget }}</span>
            </label>
          </div>
        </div>
        <div class="col-12 lg:col-6"></div>

        <div class="col-12 lg:col-6" v-if="showGeneralSettings">
          <label for="startDate" class="control-label" v-tooltip>
            {{ lmodel.pubDealStartDate }}
          </label>
          <Calendar
            id="calendar-24h"
            v-model="vmodel1.pubPauseDate"
            lang="en"
            :disabled="dealStatus == 2 || dealStatus == 3 || dealStatus == 4"
            :placeholder="lmodel.pubDealStartDatePlaceholder"
            showTime
            hourFormat="24"
            dateFormat="yy-mm-dd"
            showIcon
            :minDate="new Date()"
            class="w-full mt-1 calBorder"
          />
        </div>
        <div class="col-12 lg:col-6" v-if="showGeneralSettings">
          <label for="endDate" class="control-label" v-tooltip>
            {{ lmodel.pubDealEndDate }}
          </label>
          <Calendar
            id="calendar-24h"
            v-model="vmodel1.pubRePublishDate"
            lang="en"
            :disabled="dealStatus == 2"
            :placeholder="lmodel.pubDealEndDatePlaceholder"
            showTime
            hourFormat="24"
            dateFormat="yy-mm-dd"
            showIcon
            :minDate="new Date()"
            class="w-full mt-1 calBorder cal1"
            :panelStyle="{ 'z-index': '1006' }"
            :class="{
              'p-invalid': !valmodel.pubRePublishDate,
            }"
          />
          <span
            v-if="
              valmodel.pubRePublishDate.$invalid &&
              vmodel.pubRePublishDate != null
            "
            class="p-error"
            >{{ staticData.must_republish }}</span
          >
          <span
            v-if="
              valmodel.pubRePublishDate.$invalid &&
              vmodel.pubRePublishDate == null
            "
            class="p-error"
            >{{ staticData.republish_date }}</span
          >
        </div>
      </div>
      <div class="border-line mt-3"></div>

      <div
        :class="
          !isDisabled
            ? 'header-edit-mode text-right button-container'
            : 'head-mode text-right button-container'
        "
      >
        <PrimeButton
          id="cancelbtn"
          type="button"
          name="Cancel"
          value="cancel"
          @click="cancelBtn()"
          label="Cancel"
          class="cancel-btnadd"
        />
        <PrimeButton
          label="Save"
          class="save-btn1 ml-2 mr-2"
          icon="save-icon"
          @click="saveScheduling()"
        ></PrimeButton>
      </div>
    </div>
  </div>

  <div v-if="(isSchedule && isDisabled) || (isSave && !isSchedule)">
    <div class="grid line-text-1">
      <div class="col-12 lg:col-3">
        <label for="startDate" class="control-label1">
          {{ lmodel.pubDealStartDate }}
        </label>
      </div>
      <div class="col-12 lg:col-7">
        <label for="dateid1" class="control-labeladd">
          {{ vmodel1.pubStartDate }}
        </label>
      </div>
    </div>
    <div class="grid line-text-1">
      <div class="col-12 lg:col-3">
        <label for="endDate" class="control-label1">
          {{ lmodel.pubDealEndDate }}
        </label>
      </div>
      <div class="col-12 lg:col-7">
        <label for="dateid2" class="control-labeladd">
          {{ vmodel1.pubEndDate }}
        </label>
      </div>
    </div>
    <div class="grid line-text-1">
      <div class="col-12 lg:col-3">
        <label for="pstartDate" class="control-label1">
          {{ lmodel.pubDealPauseDate }}
        </label>
      </div>
      <div class="col-12 lg:col-7">
        <label for="dateid3" class="control-labeladd">
          {{ vmodel1.pubPauseDate }}
        </label>
      </div>
    </div>
    <div class="grid line-text-2">
      <div class="col-12 lg:col-3">
        <label for="pendDate" class="control-label1">
          {{ lmodel.pubDealRepublishDate }}
        </label>
      </div>
      <div class="col-12 lg:col-7">
        <label for="dateid4" class="control-labeladd">
          {{ vmodel1.pubRePublishDate }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import staticData from "@/staticdata/static.json";

export default {
  components: {},
  props: {
    dealId: {
      type: String,
      default: null,
    },
    isCancelClick: {
      type: Boolean,
      default: false,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false,
    },
    modelstate: {
      type: Object,
      default: null,
    },
    isSchedule: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      staticData: staticData.scheduling,
      showGeneralSettings: false,
      startOpen: false,
      pauseOpen: false,
      rePublishOpen: false,
      isSave: false,
      endOpen: false,
      isEnable: false,
      isEditMode: false,
    };
  },

  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  emits: ["call", "cancel"],
  methods: {
    cancelBtn() {
      this.$emit("cancel");
    },
    saveScheduling() {
      this.$emit("call");
      this.isSave = true;
    },
    EditData() {
      this.isEditMode = true;
    },

    toggleSettings() {
      this.showGeneralSettings = !this.showGeneralSettings;
    },
    momentFormat(date) {
      if (date) {
        return date ? moment(date).format("YYYY-MM-DD HH:mm") : "";
      }
    },
    onSubmitClickButton(value) {
      this.$emit("submitted", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  display: flex;
  align-items: center;
  // height: 120px;
  height: auto;
  padding: 26px 40px 26px 40px;
  border-radius: 4px 4px 0px 0px;
}

.header-text span {
  display: block;
  margin-top: 5px;
}

.line-text {
  align-items: center;
  padding: 20px 40px 20px 40px;
}

.line-text-1 {
  align-items: center;
  padding: 0px 40px 0px 40px;
}
.line-text-2 {
  align-items: center;
  padding: 0px 40px 15px 40px;
}

.custom-settings-button {
  padding: 5px;
  align-items: center;
}
.toggle-button {
  height: 30px;
  display: flex;
  align-items: center;
}
.toggle-button span {
  cursor: pointer;
  vertical-align: middle;
}

:deep(.p-calendar .p-button) {
  color: #000;
  background: #fff;
  border-top: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: transparent !important;
  padding: 0 !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}

:deep(.p-calendar .p-button:hover) {
  color: #000;
  background: #fff;
  border-top: 1px solid #c0c0bc;
  border-right: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  border-left: transparent !important;
  padding: 0 !important;
}

:deep(.p-calendar-w-btn .p-inputtext) {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: none !important;
}

.button-container {
  padding: 26px 40px 26px 40px;
}
.border-line {
  border-top: 1px solid #e5e5e5;
}

.control-label1 {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: bold;
  position: relative;
  vertical-align: top;
  font-family: "Voyado Text" !important;
}
.header-edit-mode {
  // background-color: #dbcece !important;
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}
:deep(.heading-text) {
  height: 19px;
  font-family: "Voyado Text";
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  text-align: left;
  color: #21211f;
}
.container-text {
  font-family: "Voyado Text";
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
  color: #21211f;
}
.icon {
  margin-left: 12px;
}

.header-edit-mode {
  background-color: #f8f8f7 !important;
}
.head-mode {
  background-color: #fff !important;
}
</style>
